import { computed } from '@vue/composition-api';
import { GoodsOfferStatus, } from '@/api/v2/requests/goods-offers';
import { date } from '@/util/formatters';
import { DummyFilter } from '@/components/Table/dummy-filter';
import { formatEntityNumber, EntityPrefix } from '@/util/entity-number';
export const useGoodsOfferColumns = (ctx) => {
    const columns = computed(() => [
        {
            field: 'internalNumber',
            headerName: '#',
            cellClass: 'ag-cell--bold',
            sortable: true,
            width: 115,
            minWidth: 115,
            flex: 0,
            valueFormatter: (params) => formatEntityNumber(EntityPrefix.GOODS_SERVICE, params.value),
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingTextFilter',
            suppressFloatingFilterButton: true,
        },
        {
            field: 'title',
            headerName: ctx.root.$t('goods-offers-table.title'),
            flex: 1,
            minWidth: 150,
            sortable: true,
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingTextFilter',
            suppressFloatingFilterButton: true,
        },
        {
            field: 'centralCost.name',
            headerName: ctx.root.$t('goods-offers-table.central-cost'),
            flex: 1,
            minWidth: 150,
            sortable: true,
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingTextFilter',
            suppressFloatingFilterButton: true,
        },
        {
            field: 'status',
            headerName: ctx.root.$t('brand-offers.status').toString(),
            width: 210,
            cellRenderer: 'GoodsOfferStatusCell',
            cellRendererParams: (params) => ({
                status: params?.data.status,
            }),
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingSelectFilter',
            floatingFilterComponentParams: () => ({
                options: Object.values(GoodsOfferStatus)
                    .filter((item) => item !== GoodsOfferStatus.DRAFT)
                    .map((status) => ({
                    value: status,
                    label: status,
                })),
                getLabel: (status) => {
                    return ctx.root.$t(`goods-offer-status.${status}`).toString();
                },
            }),
            suppressFloatingFilterButton: true,
        },
        {
            field: 'createdAt',
            headerName: ctx.root.$t('goods-offers-table.created-at'),
            sortable: true,
            cellRenderer: (params) => date(params?.data.createdAt),
        },
    ]);
    return {
        columns,
    };
};
